import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { throwError } from 'rxjs/internal/observable/throwError';
import { catchError } from 'rxjs/internal/operators/catchError';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  private apiEndpoint: string = '';
  public logo = new BehaviorSubject("");
  private notifyCountNum = new BehaviorSubject(0);
   notifyCountNumAs = this.notifyCountNum.asObservable();
  private isNotifyClick = new BehaviorSubject(false);
  isNotifyClickSub = this.isNotifyClick.asObservable();

  // To set org logo url
  public orgLogo = new BehaviorSubject({});

  constructor(private httpClient: HttpClient) {
    this.apiEndpoint = environment.APIEndpoint;
  }



  SetNotifyCount(val) {
    this.notifyCountNum.next(val);
  }
  SetNotifyEvent(val) {
    this.isNotifyClick.next(val);
  }
  setLogo(imgurl) {
    this.logo.next(imgurl);
  }

  getLatestAvatar() {
    return this.httpClient.get<any>(this.apiEndpoint + '/profile_avatar');
  }

  getLatestCoin() {
    return this.httpClient.get<any>(this.apiEndpoint + '/coins');
  }

  customerSupport(bodyConent:any) {
    let body = {
        "email": bodyConent.email,
        "body":bodyConent.message
    }
    return this.httpClient.post<any>(this.apiEndpoint + '/support/send_mail', body).pipe(catchError(this.handleError));
  }

  /**
  * To set org logo url
  */
  setOrgLogo(logoData: any) {
    if(logoData) {
      this.orgLogo.next(logoData);
    }
  }

     handleError(error) {
          let errorMessage = '';
          if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `Error: ${error.error.message}`;
          } else {
            // server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
          }
          return throwError(error);
        }
}
